import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=4f295b95&scoped=true"
import script from "./AdminManagement.vue?vue&type=script&lang=js"
export * from "./AdminManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminManagement.vue?vue&type=style&index=0&id=4f295b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f295b95",
  null
  
)

export default component.exports